import { render, staticRenderFns } from "./SupplierEmissions.vue?vue&type=template&id=1186a5ce&scoped=true"
import script from "./SupplierEmissions.vue?vue&type=script&lang=js"
export * from "./SupplierEmissions.vue?vue&type=script&lang=js"
import style0 from "./SupplierEmissions.vue?vue&type=style&index=0&id=1186a5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186a5ce",
  null
  
)

export default component.exports